<template>
  <div :id="id" v-if="stage == 'inSale'" ref="cartButton">
    <div
      class="add-to-bag"
      :data-product-id="id"
      data-button-size="large"
      :data-button-size="size"
    >
      <span class="add-to-bag__sku"> SKU {{ id }}</span>
    </div>
  </div>
  <div v-else class="shop-now-btn coming-soon">{{ $t("comingSoon") }}</div>
</template>

<script>
/*
add to cart implement cart html example
<div data-v-a74bea70="" data-v-72e631b8="" id="161531"><div data-v-a74bea70="" data-product-id="161531" data-button-size="large" class="add-to-bag" data-initialized="true"><div class="AddToBagButton__container"><div id="AddToBagButton__button-CremaComponentId-1"><button class="AddToBagButton AddToBagButtonLarge" data-focus-id="AddToBagButton__button-CremaComponentId-1" data-qa="161531"><span class="AddToBagButtonLarge__basketIcon"><i aria-hidden="true" class="Glyph Glyph--basket"></i></span><span class="VisuallyHidden">You have zero of Singles' Day Essenza Mini Bundle - Matt Black in your basket. Activate to add the product</span><span class="AddToBagButtonLarge__label" aria-hidden="true">ADD TO BASKET</span><i aria-hidden="true" class="Glyph Glyph--plus AddToBagButtonLarge__plusIcon"></i></button></div></div></div></div>
*/

export default {
  name: "addToCart",
  props: {
    id: { type: String },
    needRelpace: { type: Boolean, default: false },
    isShow: { type: Boolean, default: true },
    size: { type: String, default: "large" },
  },
  data() {
    return {
      initialized: false,
    };
  },
  inject: ["stage"],
  computed: {
    /**
     * Determines if content should be moved based on needRelpace and isShow props
     * @returns {Boolean} True if content should be moved, false if needRelpace is false
     */
    shouldMoveContent() {
      if (!this.needRelpace) return false;
      return this.needRelpace && this.isShow;
    },
  },
  watch: {
    /**
     * Watches for changes in shouldMoveContent and triggers moving when conditions are met
     * @param {Boolean} newVal - New value of shouldMoveContent
     */
    shouldMoveContent: {
      handler(newVal) {
        this.$nextTick(() => {
          // if (!this.initialized) {
          //   return;
          // }
          if (newVal) {
            this.moveAddToBagContent();
          } else {
            this.moveBackToOriginal();
          }
        });
      },
      immediate: true,
    },
  },
  mounted() {
    /**
     * Initialize content moving on component mount if conditions are met
     */
    // if (this.shouldMoveContent) {
    this.$nextTick(() => {
      // this.moveAddToBagContent();
      this.initialized = true;
    });
    // }
  },
  methods: {
    /**
     * Moves content from .add-to-bag element to the cartButton ref element
     * Uses the component's ref to target the cartButton element directly
     */
    async moveAddToBagContent() {
      try {
        if (!this.id) return;

        const source = `[data-product-id="${this.id}"][data-initialized="true"]`;
        const sourceElement = document.querySelector(source);
        const targetElement = this.$refs.cartButton;

        console.log({
          source,
          target: "cartButton ref",
          sourceElement,
          targetElement,
        });

        if (sourceElement && targetElement) {
          // Add 'original' className to parent element before moving
          const parentElement = sourceElement.parentElement;
          if (parentElement) {
            parentElement.classList.add("original");
          }

          // Move the source element to the target
          targetElement.appendChild(sourceElement);
        }
      } catch (error) {
        console.error("Error moving add-to-bag content:", error);
      }
    },

    /**
     * Moves the element back to its original position
     * Uses originalParent as anchor and gets movedElement from cartButton ref
     */
    async moveBackToOriginal() {
      try {
        if (!this.id) return;

        const originalParent = document.querySelector(
          `[id="${this.id}"].original`,
        );
        const movedElement = this.$refs.cartButton?.querySelector(
          '[data-initialized="true"]',
        );

        console.log({
          originalParent,
          movedElement,
        });

        if (movedElement && originalParent) {
          // Move the element back to the original parent
          originalParent.appendChild(movedElement);

          // Remove the 'original' className from parent
          originalParent.classList.remove("original");
        }
      } catch (error) {
        console.error("Error moving element back to original position:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";
.add-to-bag__sku {
  display: none;
}
.shop-now-btn {
  background: color(successGreen);
  color: color(white);
  border: none;
  border-radius: rem(10);
  padding: rem(12);
  // height: rem(49);
  // margin-top: rem(24);
  width: 100%;

  font-weight: 400;
  font-size: rem(18);
  line-height: 1.2;
  letter-spacing: rem(2);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 200px;

  &.coming-soon {
    background: #a2a2a2;
    cursor: not-allowed;
  }

  @include media-breakpoint-down(md) {
    padding: rem(12);
    font-size: rem(16);
  }
}
</style>
